const user_routes = {
    auth: {
        login: "/auth",
        get_password: "/auth/password",
        register: "/auth/register",
        get_otp: "/auth/otp",
        create_password: "/auth/create-password",
        forget: "/auth/forget",
        forget_otp: "/auth/forget/confirm",
        new_password: "/auth/new-password",
        sejam: "/auth/sejam",
        fund: "/auth/fund",
        card: "/auth/card",
        check_user: "/auth/check",
    },
    dashboard: {
        home: "/",
        accounts: "/accounts",
        accounts_edit: "/accounts/edit",
        profile: "/profile",
        refund: (fund_id) => `/refund/${fund_id}`,
        cashout: (fund_id) => `/cashout/${fund_id}`,
        fundReport: "/funds-report",
        account_report: `/accounts/report`,
    },
};

const admin_routes = {
    customers: "/customers",
    home: "/",
    login: "/signin",
    managers: "/users",
    messageAdd: "/message/add",
    messageEdit: "/message/edit",
    notifications: "/notifications",
    profile: "/profile",
    roles: "/roles",
    transactions: "/transactions",
    orders: "/orders",
    sellReport: "/reports/sell-orders",
    sellReportCMS: "/reports/cms-sell-orders",
    superAdminReport: "/reports/superAdmin",
    providersReport: "/reports/providers",
    cardDailyReport: "/reports/cards-daily",
    settings: "/settings",
    invite: "/invite",
    policy: "/policy",
    faq: "/faq",
    reinvestingPercent: "/reinvesting",
    invitedUsers: "/reports/users-invited",
    usersBuySell: "/reports/users-buy-sell",
    disabledAccounts: "/reports/disabled-accounts",
    jobs: "/jobs",
    payLink: "/payment-link",
    userDeposit: "/user-deposit",
    userCashOut: "/user-cashout",
    consultationsList: "/consultations-list",
};

export { admin_routes, user_routes };

